export enum ClickTarget {
  SelfSignupSubmitClick = 'self-signup-submit-click',
  PostAJobClick = 'post-job-click',
  SaveAndSubscribeClick = 'save-and-subscribe-click',
  // Employer self-service transactional registration flow
  SignUpStart = 'sign-up-start',
  SignUpSubmit = 'sign-up-submit',
}
